import { requiredOptionMessage } from "../validationMessages";

import { trimmedString } from "./trimmedString";

export const radioValidator = trimmedString.required(requiredOptionMessage);
